import { render, staticRenderFns } from "./EditedBy.vue?vue&type=template&id=7f0b1f4c&scoped=true"
import script from "./EditedBy.vue?vue&type=script&lang=js"
export * from "./EditedBy.vue?vue&type=script&lang=js"
import style0 from "./EditedBy.vue?vue&type=style&index=0&id=7f0b1f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b1f4c",
  null
  
)

export default component.exports